import React from 'react';
import Table from 'react-bootstrap/Table';
import './StripeStatusTable.css'; // Import custom CSS

function StripeStatusTable({ stripeStatus, planName }) {
  const stringLookup = {
    'current_period_end': 'Renewal/End Date',
    'current_period_start': 'Start Date',
    'cancel_at_period_end': 'Cancel At Period End',
    'canceled_at': 'Canceled At',
    'stripe_sub_status': 'Subscription Status',
    'plan_name': 'Subscription Plan',
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      year: 'numeric', month: 'short', day: '2-digit'
    }).split(' ').reverse().join('-'); // Simplified date formatting
  };

  const titleCase = (str) => {
    return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  };

  const getDisplayValue = (key, value) => {
    if (['current_period_end', 'current_period_start', 'canceled_at'].includes(key)) {
      return formatDate(value);
    }
    return key === 'cancel_at_period_end' ? (value ? 'Yes' : 'No') :
           key === 'stripe_sub_status' ? (value ? value.charAt(0).toUpperCase() + value.slice(1) : 'N/A') :
           key === 'plan_name' ? titleCase(value ? value.toString() : 'N/A') :
           value ? value.toString() : 'N/A';
  };

  // Add planName to stripeStatus and set default to 'basic' if neither exists
  const processedStripeStatus = {
    ...stripeStatus,
    plan_name: planName || stripeStatus.plan_name || 'basic'
  };

  // Define the desired order of keys
  const keyOrder = ['current_period_start', 'current_period_end', 'stripe_sub_status', 'plan_name', 'cancel_at_period_end', 'canceled_at'];
  
  // Create ordered object based on keyOrder, only including keys that exist
  const orderedStatus = {};
  keyOrder.forEach(key => {
    if (processedStripeStatus.hasOwnProperty(key)) {
      orderedStatus[key] = processedStripeStatus[key];
    }
  });

  // Add any remaining keys that weren't in keyOrder
  Object.keys(processedStripeStatus).forEach(key => {
    if (!orderedStatus.hasOwnProperty(key)) {
      orderedStatus[key] = processedStripeStatus[key];
    }
  });

  // If cancel_at_period_end is false, remove canceled_at and cancel_at_period_end keys
  if (processedStripeStatus.cancel_at_period_end === false) {
    delete orderedStatus.canceled_at;
    delete orderedStatus.cancel_at_period_end;
  }
  
  return (
    <div className="stripe-status-table">
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Title</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(orderedStatus).map(([key, value]) => (
            <tr key={key}>
              <td>{stringLookup[key] || key}</td>
              <td>{getDisplayValue(key, value)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default StripeStatusTable;